import { TAccountRightsFeatureList } from '@app/services/account-rights-service/response-interfaces/account-rights';

export const FEATURE_BASE_MARGIN_MATRIX: TAccountRightsFeatureList =
  'BaseMarginMatrix';
export const FEATURE_EXCEPTIONS: TAccountRightsFeatureList = 'Exceptions';
